import Vue from 'vue';
import { VuexBuilder } from '@helpers/vuexBuilder';


const state = {
	types: [],
	types_loaded: false,
	types_loading: false,
	operations: {
		get: false,
		list: false,
		uploading: false,
		deleting: false,
	}
}

const getters = {
	getTypes: state => state.types.filter(x => !x.isDeleted).map(x => ({ ...x, inUse: x.references.length > 0 })),
	getActive: state => state.types.filter(x => !x.isDeleted).map(x => ({ ...x, inUse: x.references.length > 0 })),
	hasLoaded: state => state.types_loaded,
	isGetting: state => state.operations.get,
	isListing: state => state.operations.list,
	isUploading: state => state.operations.uploading,
	isDeleting: state => state.operations.deleting
}

const actions = {
	async initialize({commit, state, dispatch}) {
		if (!state.types_loaded && !state.types_loading) {
			commit('SET_LOADING', true);
			await dispatch('get')
			commit('SET_LOADING', false);
		}
	},
	async get({ commit, rootState }) {
		return await new VuexBuilder(commit)
			.operationKey("list")
			.request(() => Vue.axios.get(`/api/${rootState.tenantId}/certificationtypes`))
			.commitData('GET_SUCCESS')
			.execute()
	},

	async upsert({ commit, rootState }, payload) {
		const operationTitle = payload.id ? "update" : 'create'

		return await new VuexBuilder(commit)
			.operationKey("uploading")
			.request(() => Vue.axios.post(`/api/${rootState.tenantId}/certificationtypes`, payload))
			.successToast(`Successfully ${operationTitle}d certification type`)
			.errorToast(`Failed to ${operationTitle} certification type`)
			.commitData('UPDATE_SUCCESS')
			.execute()
	},

	async updateArchiveStatus({ commit, rootState }, payload) {
		const operationTitle = payload.isDeleted ? "archive" : 'un-archive'

		return await new VuexBuilder(commit)
			.operationKey("uploading")
			.request(() => Vue.axios.post(`/api/${rootState.tenantId}/certificationtypes`, payload))
			.successToast(`Successfully ${operationTitle}d certification type`)
			.errorToast(`Failed to delete certification type`)
			.commitData('UPDATE_SUCCESS')
			.execute()
	},
}

const mutations = {
	SET_LOADING(state, loading) {
		state.types_loading = loading;
	},
	START_OPERATION(state, operationKey) {
		state.operations[operationKey] = true
	},
	FINISH_OPERATION(state, operationKey) {
		state.operations[operationKey] = false
	},
	GET_SUCCESS(state, data) {
		state.types_loaded = true;
		state.types = data;
	},
	UPDATE_SUCCESS(state, certificationTypes) {
		const updates = Array.isArray(certificationTypes) ? certificationTypes : [certificationTypes];
		for (const update of updates) {
			const index = state.types.findIndex(x => x.id === update.id);
			if (index > -1) {
				state.types.splice(index, 1, update)
			}
			else {
				state.types.push(update)
			}
		}
	},
	DELETE_SUCCESS(state, id) {
		const index = state.types.findIndex(a => a.id === id);
		if (index > -1) {
			state.types.splice(index, 1);
		}
	},
}

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
};